import { render, staticRenderFns } from "./BuyNoticePopup.vue?vue&type=template&id=0bdf8194&scoped=true&"
import script from "./BuyNoticePopup.vue?vue&type=script&lang=js&"
export * from "./BuyNoticePopup.vue?vue&type=script&lang=js&"
import style0 from "./BuyNoticePopup.vue?vue&type=style&index=0&id=0bdf8194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdf8194",
  null
  
)

export default component.exports